// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__16DWc","inner":"Footer_inner__1uiHt"};